import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

export const experienceDesignationSchema = z.object({
  title: z.string(),
  date: z.string(),
});

// Schema
export const experienceSchema = itemSchema.extend({
  company: urlSchema,
  position: z.string(),
  location: z.string(),
  date: z.string(),
  summary: z.string(),
  url:  z.any(),
  companyDescription: z.string().max(90).optional().default(""),
  designations: z.array(experienceDesignationSchema).default([]),
});

// Type
export type Experience = z.infer<typeof experienceSchema>;

// Defaults
export const defaultExperience: Experience = {
  ...defaultItem,
  company: defaultUrl,
  position: "",
  location: "",
  date: "",
  summary: "",
  url: defaultUrl,
  companyDescription: "",
  designations: [],
};
